module.exports = __webpack_public_path__ + "static/media/labor.3c42f899.svg";